import { cn } from "@/lib/utils";
import { ArrowUpRight, ArrowDownRight, MoreHorizontal } from "lucide-react";

export default function StatCard({
    label,
    value,
    delta,
    deltaDirection = "up", // up | down
    caption,
    Icon,
    accent = "brand", // brand | success | warning | info
    testId,
}) {
    const accents = {
        brand: "bg-[hsl(var(--brand))]/10 text-[hsl(var(--brand))]",
        success: "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]",
        warning: "bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]",
        info: "bg-[hsl(var(--info))]/10 text-[hsl(var(--info))]",
    };
    const isUp = deltaDirection === "up";

    return (
        <div className="stat-card" data-testid={testId}>
            <div className="flex items-start justify-between">
                <div>
                    <div className="text-[12.5px] font-medium text-muted-foreground">{label}</div>
                    <div className="mt-3 flex items-baseline gap-2">
                        <span className="text-[28px] font-bold tracking-tight text-foreground leading-none">
                            {value}
                        </span>
                        {delta && (
                            <span className={cn(
                                "inline-flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-[11px] font-semibold",
                                isUp
                                    ? "bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]"
                                    : "bg-[hsl(var(--destructive))]/10 text-[hsl(var(--destructive))]"
                            )}>
                                {isUp ? <ArrowUpRight className="h-3 w-3" /> : <ArrowDownRight className="h-3 w-3" />}
                                {delta}
                            </span>
                        )}
                    </div>
                    {caption && (
                        <div className="mt-2 text-[11.5px] text-muted-foreground">{caption}</div>
                    )}
                </div>
                <div className="flex items-center gap-1">
                    {Icon && (
                        <div className={cn("flex h-10 w-10 items-center justify-center rounded-xl", accents[accent])}>
                            <Icon className="h-5 w-5" />
                        </div>
                    )}
                    <button type="button" aria-label="Seçenekler" className="inline-flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted">
                        <MoreHorizontal className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
